<template>
    <div class="container">
      
      <h2 class="text-center hidden-xs"><i class="fa fa-vcard-o"></i> Manage your Account Info</h2>
      <h3 class="text-center hidden-sm hidden-md hidden-lg"><i class="fa fa-vcard-o"></i> Manage your Account Info</h3>
      <div class="col-sm-12">
        <hr>
         <div class="alert alert-danger" v-if="error">
            <p>{{ error }}</p>
          </div>
         <div class="alert alert-info" v-if="alert">
            <p>{{ alert }}</p>
          </div>
        </div>
          <div class="modal fade" id="accountManager" data-backdrop="static" show="true" data-keyboard="false" role="dialog" aria-labelledby="modalLabel" tabindex="-1">
            <div class="modal-dialog ">
              <div style="padding:0px;" class="modal-content col-sm-offset-2 col-sm-8">
                <div class="modal-header">
                  <h3 style="margin-top:0px; margin-bottom:0px;"><i class="fa fa-cog"></i> Account Management</h3>
                </div>
                <div class="modal-body " style="overflow:hidden; margin-top:0px;">
                  <div class="well" style="margin-top:0px; margin-bottom:0px;">
                        <div >
                            <h4 class="text-center">Administrative Settings</h4>
                            <button v-if="userDataComp.Provider!='Facebook'" class="btn btn-block btn-default" @click="changePassword()">Change Password</button>
                            <button v-if="compUserRole=='Sitter'" class="btn btn-block btn-premium" @click="goSubscribe()">Go Premium <i class="fa fa-paw"/></button>
                            <button v-if="compUserRole=='Client'" class="btn btn-block btn-success" @click="goSubscribe()"><i class="fa fa-credit-card"/> Subscribe</button>
                            <button v-if="compUserRole!=admin" class="btn btn-block btn-warning" @click="confirmSwitchAccount()">Switch account to Sitter or Client</button>
                            <button v-if="compUserRole=='Sitter'" class="btn btn-block btn-danger" @click="goSuspend()">Suspend Account <i class="fa fa-warning"/></button>
                          </div>
                  </div>
                  <br>
                <div class="pull-right">
                <br>
                <button class="btn btn-default" @click="hideAccountManagementModal()">Close</button>
              </div>
                </div>
              </div>
        </div>
      </div>
        <div class="col-sm-6  col-md-5 col-lg-4 col-xs-12">          
        <h4>Profile Photo</h4>
        <ProfilePicUpload style="padding-left:0px; min-height:210px;"></ProfilePicUpload>
        <!--<h4>Logged in as <strong>{{compUserRole}}</strong></h4>
        <h4 v-if="subscriptionExpiryComp">Subscription Expires <strong>{{subscriptionExpiryComp}}</strong></h4>-->
        <hr>
        
        <h4>Email</h4>
        <div class="input-group">
        <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
         <input v-model="userDataComp.UserName" disabled class="form-control"></input>
         <span class="input-group-addon">
             <a @click="verifyEmail()" href="javascript:;" class="text-success"><strong>{{emailStatusComp}}</strong></a>
          </span>
        </div>
        <h4>First Name</h4> <input v-model="userDataComp.FirstName" class="form-control"></input>
        <h4>Last Name</h4> <input v-model="userDataComp.LastName" class="form-control"></input>
        <h4>Mobile Phone <span v-if="compUserRole=='Sitter'" class="red-star" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Required to publish your profile">★</span></h4>
        <div class="input-group">
          <span class="input-group-addon" id="basic-addon1">{{userDataComp.CountryCode}}</span>
           <input type="number" pattern="\d*" :disabled="phoneNumberConfirmedComp" v-model="userDataComp.PhoneNumber" class="form-control"></input>
            <span v-if="phoneNumberComp" class="input-group-addon">
             <a @click="verifyPhone()" href="javascript:;" class="text-success"><strong>{{phoneStatusComp}}</strong></a>
          </span>
        </div>
                
        <br>
        <button @click="showAccountManagementModal()" class="btn btn-block btn-default">Optional Settings</button>
        <br>
        <button @click="updateUser()" class="btn btn-block btn-success">Save changes</button>
        <br>
       
        </div>
        
        <div>
       
        </div>
        

             <div class="modal fade" id="changePassword" role="dialog" aria-labelledby="modalLabel" tabindex="-1">
                <div class="modal-dialog">
                  <div class="modal-content ">
                    <div class="modal-header">
                      <h4> Change Password</h4>
                    </div>
                    <div class="modal-body" style="overflow:hidden;">
                      <div class="well" style="overflow: hidden">
                            <ChangePassword style="padding-left:0px"></ChangePassword>       
                      </div >  <!--end of modal well-->
                    </div> <!--end of modal body-->
                  </div> <!--end of modal content-->
                </div>
              </div>

              <div class="modal fade" id="verifyEmail" role="dialog" aria-labelledby="modalLabel" tabindex="-1">
                <div class="modal-dialog">
                  <div class="modal-content ">
                    <div class="modal-header">
                      <h4> Verify Email</h4>
                    </div>
                    <div class="modal-body" style="overflow:hidden;">
                      <div class="well" style="overflow: hidden">
                              <VerifyEmail style="padding-left:0px"> </VerifyEmail>                
                      </div >  <!--end of modal well-->
                    </div> <!--end of modal body-->
                  </div> <!--end of modal content-->
                </div>
              </div>

              <div class="modal fade" id="verifyPhone" role="dialog" aria-labelledby="modalLabel" tabindex="-1">
                <div class="modal-dialog">
                  <div class="modal-content ">
                    <div class="modal-header">

                    <!--My changes here-->
                    <!--Branch Zawer-->
                    <!--Branch Zawer-->

                      <h4> Verify Phone Number</h4>
                    </div>
                    <div class="modal-body" style="overflow:hidden;">
                      <div class="well" style="overflow: hidden">
                              <VerifyPhone :countryCode="countryDataComp.CountryCode" :mobileNumber="userData.PhoneNumber" style="padding-left:0px"> </VerifyPhone>                
                      </div >  <!--end of modal well-->
                    </div> <!--end of modal body-->
                  </div> <!--end of modal content--> 
                </div>
              </div>
             
          
          

            



         </div>
         
    
</template>

<script>
  
  import auth from '../../auth/index'
  import store from '../../data/store'
  import ChangePassword from './ChangePassword.vue'
  import VerifyEmail from './VerifyEmail.vue'
  import VerifyPhone from './VerifyPhone.vue'
  import ProfilePicUpload from './ProfilePicUpload.vue'
  

  export default {
    name: 'AccountView',
    data() {
      return {  
          error: '',
          userData: '',
          alert: '',
          number: '',
          admin: "Admin",
      }
    },
    updated(){
      this.$ga.page(this.$router)
        $('[data-toggle="popover"]').popover();
        // $zopim(function (){
        //     $zopim.livechat.sendVisitorPath();
        // });
    },
    methods: {
       hideAccountManagementModal(){
           $('#accountManager').modal('hide');
       },
       showAccountManagementModal(){
           $('#accountManager').modal('show');
       },
      changePassword(){
        $('#changePassword').modal('show');
      },
      verifyEmail(){

        $('#verifyEmail').modal('show');
      },
      verifyPhone(){
        var self = this;
        $('#verifyPhone').modal('show');
      },
      confirmSwitchAccount(){
        var self = this
           swal({
              title: "Switch Account Confirmation",
              text: "You are currently logged in as " + self.compUserRole + " if you click yes your account type will be changed and you will be logged out and prompted to login again, you can revert back to " + self.compUserRole + " anytime",
              type: "info",
              showCancelButton: true,
              confirmButtonClass: 'btn-success',
              confirmButtonText: "Yes, switch account",
              closeOnConfirm: true,
              html: true
            }, function(){
              self.switchAccount()
            });
            
      },
      suspendAccountConfirm(){
        var self = this
          $.ajax("https://www.dupaws.com/services/api/sitter/suspendAccount/",  {
                    type: 'GET',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                      console.log('succes')
                         swal({
                            title: 'Account Suspended',
                            text: "Your account was suspended as per your request, to enable it back send an email to info@dupaws.com",
                            type: "success",
                            confirmButtonClass: "btn-success",
                            confirmButtonText: 'Woof!',
                           allowOutsideClick: false,
                            closeOnConfirm: true,
                            },
                            function(isConfirm) {
                                return;
                            });
                    },
                    error: function () {
                      swal("error", "a problem happened while trying to suspend your account, please contact support", "error")
                    }
                }); 
      },
      goSuspend(){
        var self = this
          swal({
                    title: "Are you sure you want to suspend your account?",
                    text: "By doing so your profile will no longer be visible to any user, the only way to enable it back is to send us an email and request your account to be re-enabled",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: 'btn-danger',
                    cancelButtonClass: 'btn-default',
                    confirmButtonText: "Yes Suspend",
                    cancelButtonText: "Cancel",
                    allowOutsideClick: false,
                    closeOnConfirm: false,
                   
                    }, function(isConfirm){
                    if (isConfirm){
                      self.suspendAccountConfirm()
                      return;
                    } else {
                        
                    }
                });
      },
      goSubscribe(){
        var self = this
        self.hideAccountManagementModal()
        if (store.getters.SubscriptionStatus.IsActive==true){
          
          swal("Subscription Status", "Your membership is active, you can upgrade when it expires", "success")
        } else {
          self.$router.push({path: '/subscribe'})
        }
      },
      switchAccount(){
        var self = this
        $.ajax({
            type: 'GET',
            url: 'https://www.dupaws.com/services/api/account/SwitchRole/' + self.countryDataComp.CountryId,
            contentType: "application/json; charset=utf-8",
            beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
            },
            success: function (data) {
                    self.alert  = data
                    auth.logout()
                    self.$router.push({path: '/login', query: {switch: 'yes'}})
                    // router.go({path: '/login', query: {switch: 'yes'}}) //workaround for refreshing the page and keeping path at /login.. dirty stuff...
                  
            },
            error:function(){
            try {
                    self.error = "Failed switching account"
            } catch(e)
            {
                self.error = "Oops we are having problem logging to the server, please try again in a moment.."
            }
                
            }
      });
      },
      updateUser(){
        var self = this
        if (!self.userData.FirstName || !self.userData.LastName)
            {
                swal("Something is missing", "Please fill in First and Last Name before saving","info")
                return
        }
        $.ajax({
            type: 'POST',
            url: 'https://www.dupaws.com/services/api/account/updateUser',
            data: JSON.stringify(self.userData),
            contentType: "application/json; charset=utf-8",
            beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
            },
            success: function (data) {
                    self.alert  = data
                    
                    localStorage.setItem('firstName', self.userData.FirstName)
                    localStorage.setItem('lastName', self.userData.LastName)
                    localStorage.setItem('phoneNumber', self.userData.PhoneNumber)
                    store.commit('firstName', localStorage.getItem('firstName'))
                    store.commit('lastName', localStorage.getItem('lastName'))
                    store.commit('phoneNumber', localStorage.getItem('phoneNumber'))
                    self.$router.push({path:'/'})
            },
            error:function(){
            try {
                    self.error = "Updating user failed, try again.."
            } catch(e)
            {
                self.error = "Oops we are having problem logging to the server, please try again in a moment.."
            }
                
            }
      });
      },
      updateSitter(route){
        var self = this
        if (!self.userData.FirstName || !self.userData.LastName)
            {
                swal("Something is missing", "Please fill in First and Last Name before saving","info")
                return
        }
        $.ajax({
            type: 'POST',
            url: 'https://www.dupaws.com/services/api/account/updateUser',
            data: JSON.stringify(self.userData),
            contentType: "application/json; charset=utf-8",
            beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
            },
            success: function (data) {
                    self.alert  = data
                    
                    localStorage.setItem('firstName', self.userData.FirstName)
                    localStorage.setItem('lastName', self.userData.LastName)
                    localStorage.setItem('phoneNumber', self.userData.PhoneNumber)
                    store.commit('firstName', localStorage.getItem('firstName'))
                    store.commit('lastName', localStorage.getItem('lastName'))
                    store.commit('phoneNumber', localStorage.getItem('phoneNumber'))
                    if (route=="dashboard"){
                      self.$router.push({path:'/dashboard/feedback-performance'})
                    } else if (route=="calendar"){
                      self.$router.push({path:'/sitter-profile-edit/calendar'})
                    } else {
                      self.$router.push({path:'/'})
                    }
                    
            },
            error:function(){
            try {
                    self.error = "Updating user failed, try again.."
            } catch(e)
            {
                self.error = "Oops we are having problem logging to the server, please try again in a moment.."
            }
                
            }
      });
      }
      
    },
    mounted: function() {
      var self = this
      
        $.ajax({
            type: 'GET',
            url: 'https://www.dupaws.com/services/api/account/whoami',
            beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
            },
            success: function (data) {
                    self.userData = data
                    store.commit('profilePicUrl', data.ProfilePicUrl)
                    localStorage.setItem('profilePicUrl',data.ProfilePicUrl)
            },
            error:function(error){
            try {
                    self.error = error.responseJSON
            } catch(e)
            {
                self.error = "Oops we are having problem logging to the server, please try again in a moment.."
            }
                
            }
      });
    },
    computed: {
      // subscriptionExpiryComp: function(){
      //   if (this.userDataComp.SubscriptionExpiry)
      //     return moment(this.userDataComp.SubscriptionExpiry).format('DD MMM YYYY')
      // },
      phoneNumberComp: function(){
        if (this.userDataComp.PhoneNumber!=null){
        if (this.userDataComp.PhoneNumber.startsWith(this.countryDataComp.CountryCode,0)){
            swal("Phone Number", "Please enter your phone number without country code", "info")
            return false
          }
          if (this.userDataComp.PhoneNumber.length>10){
            swal("Phone Number", "Phone number incorrect, maximum length should be 10 numbers", "info")
            return false
          }
        
          if (this.userDataComp.PhoneNumber.length>6)
            return true
          
        else 
          return false
          }
      },
      countryDataComp: function(){
        return store.getters.CountryData
      },
      phoneNumberConfirmedComp: function(){
        if (store.getters.PhoneConfirmed==true || localStorage.getItem('phoneConfirmed')=="True")
          return true
        else  
          return false
      },
      compUserRole: function(){
         return store.getters.userRole
      },
      userDataComp: function(){
        if (this.userData!=null)
          return this.userData
      },
      emailStatusComp(){
        if (localStorage.getItem('emailConfirmed')=="True")
          return 'Email Confirmed'
        else
          return 'Confirm Email'
      },
      phoneStatusComp(){
        if (store.getters.PhoneConfirmed==true || localStorage.getItem('phoneConfirmed')=="True")
          return 'Mobile Confirmed'
        else
          return 'Confirm Mobile'
      }
  },
  components: {
      ChangePassword,
      VerifyEmail,
      VerifyPhone,
      ProfilePicUpload,
      
    }
  }

</script>


<style scoped>
 .tab-content {
     padding: 10px
}
.fade {
    display: none;

}


</style>


// WEBPACK FOOTER //
// AccountView.vue?6f4f5dac